import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import ReadMoreLess from "../ReadMoreLess";
function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text className="text-muted" style={{ textAlign: "justify" }}>
          <ReadMoreLess text={props.description} maxLength={90} />
        </Card.Text>
        <Button
          variant="primary"
          href={props.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <BiLinkExternal /> &nbsp;
          {"View Project"}
        </Button>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
